import React from 'react'
import ProjectItem from '../components/ProjectItem';
import shoppingCart from '../assets/shoppingCart.PNG';
import randomRecipeApp from '../assets/randomRecipeApp.PNG';
import loginRegister from '../assets/loginRegister.PNG';
import passwordValidation from '../assets/passwordValidation.PNG';
import movieApp from '../assets/movieApp.PNG';
import weatherApp from '../assets/weatherApp.PNG';
import todo from '../assets/todo.PNG';
import ticTacToe from '../assets/ticTacToe.PNG';
import calculator from '../assets/calculator.PNG';
import '../styles/Projects.css';
import { ProjectList } from '../helpers/ProjectList';
const Projects = () => {
  return (
      <div className="projects">
          <h1 style={{fontSize: '30px'}}>My personal Projects</h1>
          <div className="projectList">
              {/* <ProjectItem name="Shopping Cart" image={shoppingCart}/>
              <ProjectItem name="Random recipe app" image={randomRecipeApp } />
          <ProjectItem name="Login Register form" image={loginRegister}/>
           <ProjectItem name="Password Validation" image={passwordValidation}/>
              <ProjectItem name='Movie app' image={movieApp} />
              <ProjectItem name="Weather app" image={weatherApp} />
              <ProjectItem name="To do list" image={todo} />
              <ProjectItem name="Tic tac toe" image={ticTacToe} />
              <ProjectItem name="Calculator" image={calculator} />
    */}
        {ProjectList.map((project,idx) => {
          return <ProjectItem id={idx} name={project.name} image={project.image}  />
        })}
          </div>
    </div>
  )
}

export default Projects